import { Clickable, List, P } from '@ahmdigital/ui';

const data = [
  {
    body: (
      <>
        <P>First, just know it’s not your fault and there’s help available.</P>
        <P>Collect as much information as you can about the scam. Including:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>What happened?</li>
          <li>When did it happen?</li>
          <li>Who contacted you?</li>
          <li>How did you respond?</li>
        </List>

        <P>
          File a report at{' '}
          <Clickable to="https://www.cyber.gov.au/report-and-recover/report">ReportCyber with these details.</Clickable>
        </P>
        <P>
          If you’ve supplied financial information (including credit card details, bank account, or debit card
          information), or think a third party may have gained access to your financial information, get in touch with
          your bank immediately.
        </P>
        <P>
          Help others to spot new and emerging scams, by reporting to{' '}
          <Clickable to="https://portal.scamwatch.gov.au/report-a-scam/">Scamwatch</Clickable>
        </P>
        <P variant={['strong']}>Need more support? Reach out to:</P>
        <List variant={['withoutListStyle', 'withBottomMargin']}>
          <li>
            <Clickable to="https://www.beyondblue.org.au/">Beyond Blue</Clickable>
            <P>
              <Clickable to="tel:1300224636">1300 22 4636</Clickable> or{' '}
              <Clickable to="https://www.beyondblue.org.au/support-service/chat">online chat</Clickable> (24 hours a
              day, 7 days a week)
            </P>
          </li>
          <li>
            <Clickable to="https://www.lifeline.org.au/">Lifeline</Clickable>
            <P>
              <Clickable to="tel:131114">13 11 14</Clickable> or{' '}
              <Clickable to="https://www.lifeline.org.au/crisis-chat/">online crisis support chat</Clickable> (24 hours
              a day, 7 days a week)
            </P>
          </li>
        </List>
      </>
    ),
    title: 'What to do if you think you’ve been scammed.',
  },
  {
    body: (
      <>
        <P>If you’ve clicked on a suspicious link, don’t panic! </P>
        <P>Here’s what you can do:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            Disconnect your device from the internet. This may help to prevent any{' '}
            <Clickable to="https://www.cyber.gov.au/threats/types-threats/malware">malware</Clickable> (malicious
            software) from spreading to other devices on your network or stealing your personal information.
          </li>
          <li>
            Scan your device for any viruses or malware that may have been downloaded when you clicked the suspicious
            link. (You may need to download and install an antivirus program to do this if you don’t have one already.)
          </li>
          <li>Change your passwords for all your online accounts, including your ahm account. </li>
          <li>Monitor your bank account for any suspicious activity. </li>
          <li>
            File a report at <Clickable to="https://www.cyber.gov.au/report-and-recover/report">ReportCyber.</Clickable>
          </li>
        </List>
      </>
    ),
    title: 'Suspicious links',
  },
  {
    body: (
      <>
        <P>
          We’ll never contact you to demand money, ask for the password for your ahm account, your sensitive
          information, or call you outside our business hours unless we’ve set this up with you. (If you have previously
          placed a security question or PIN on your ahm account, we’ll use this to confirm your identity every time you
          contact us.)
        </P>
        <P variant={['strong']}>Some more tips:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>If the caller is threatening you or pressuring you to make a decision, hang up the phone.</li>
          <li>Never let anyone control your accounts or devices remotely unless you have verified their identity.</li>
          <li>If the caller makes an offer that sounds too good to be true, it probably is.</li>
          <li>
            If you’re unsure about the identity of the caller, hang up and{' '}
            <Clickable to="https://ahm.com.au/contact-us">get in touch</Clickable> with us directly.
          </li>
        </List>
        <P>
          Visit <Clickable to="https://ahm.com.au/explained/how-to-protect-yourself">How to Protect Yourself</Clickable>{' '}
          for more details.
        </P>
      </>
    ),
    title: 'Is it really ahm contacting me?',
  },
];

export default data;
